import React from 'react';
import Page from "@/components/layout/Page";
import StaticContent from '@/components/common/StaticContentPage';

const StaffPicksHelp = () => {
	return (
		<Page pageTitle={"Staff Picks"}>
      <StaticContent header={'Staff Picks'}>
				<div>
					<h3 className={`font-gSemi text-base`}>{`What are Staff Picks?`}</h3>
					<p className='font-gReg text-base'>{`Our team's top trivia Playlists for the month - weird, wild, and wonderful!`}</p>
				</div>
				<div>
					<h3 className={`font-gSemi text-base`}>{`Who chooses the Picks?`}</h3>
					<p className='font-gReg text-base'>{`Handpicked by members of the Trivial Pursuit Infinite team for maximum fun!`}</p>
				</div>
				<div>
					<h3 className={`font-gSemi text-base`}>{`New Picks Every Month?`}</h3>
					<p className='font-gReg text-base'>{`Absolutely! A fresh batch of curiosity monthly.`}</p>
				</div>
			</StaticContent>
		</Page>
	);
};

export default StaffPicksHelp;
